<template>
  <div>
    <div class="float-left">
      <!-- <h4 class="font-weight-bold mt-3">Comments</h4>
      <div class="row m-0 p-0">
        <a href="/" style="margin-top: -3px;">
          <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.10302 0.473538C6.91735 0.298002 6.67153 0.200195 6.41602 0.200195C6.16051 0.200195 5.91469 0.298002 5.72902 0.473538L0.885016 5.05154C0.736698 5.19189 0.618598 5.36105 0.537952 5.54865C0.457307 5.73625 0.415814 5.93834 0.416016 6.14254V11.7125C0.416281 12.1102 0.574434 12.4915 0.85571 12.7726C1.13699 13.0536 1.51836 13.2115 1.91602 13.2115H3.41602C3.81384 13.2115 4.19537 13.0535 4.47668 12.7722C4.75798 12.4909 4.91602 12.1094 4.91602 11.7115V9.21154C4.91602 9.07893 4.9687 8.95175 5.06246 8.85798C5.15623 8.76422 5.28341 8.71154 5.41602 8.71154H7.41602C7.54862 8.71154 7.6758 8.76422 7.76957 8.85798C7.86334 8.95175 7.91602 9.07893 7.91602 9.21154V11.7115C7.91602 12.1094 8.07405 12.4909 8.35536 12.7722C8.63666 13.0535 9.01819 13.2115 9.41602 13.2115H10.916C11.3138 13.2115 11.6954 13.0535 11.9767 12.7722C12.258 12.4909 12.416 12.1094 12.416 11.7115V6.14154C12.416 5.93743 12.3742 5.73549 12.2934 5.54807C12.2126 5.36065 12.0944 5.19169 11.946 5.05154L7.10302 0.471538V0.473538Z"
              fill="#48a6a6" />
          </svg>
        </a>
        <span style="margin: -3px 12px 0 12px;">
          <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.227539 1.79558L1.27235 0.750765L6.22754 5.70595L1.27235 10.6611L0.227539 9.61632L4.13791 5.70595L0.227539 1.79558Z" fill="#9A9AB0" />
          </svg>
        </span>
        <breadcrumbs />
      </div> -->
    </div>
    <br />
    <br />
    <br />
    <div class="card card-body p-0" style="border-radius: 10px">
      <div class="table-responsive">
        <table class="table border-bottom table-hover text-center" id="dataTable" width="100%" cellspacing="0">
          <thead>
            <tr>
              <th>Comment</th>
              <th>Post</th>
              <th>User</th>
              <!-- <th>Votes</th> -->
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr  v-if="isLoader" id="table_row" >
              <td colspan="16">
                <b-skeleton-wrapper >
                    <b-skeleton height="40px" ></b-skeleton>   
                    <b-skeleton height="40px"></b-skeleton>  
                    <b-skeleton height="40px"></b-skeleton>                                     
                </b-skeleton-wrapper> 
              </td>
            </tr>
            <comment-row v-show="!isLoader" v-for="comment in comments" :comment="comment" :key="comment.id"></comment-row>
          </tbody>
        </table>

        <h5 style="text-align: center; margin-top:2rem;" v-if="comments.length < 1 && !isLoader">
          No data found.
        </h5>

        <paginate v-if="!isLoader" v-model="page" :page-count="totalPages" :click-handler="setPage" :prev-text="''" :next-text="''"
          :first-button-text="''" :last-button-text="''" :first-last-button="true"
          :container-class="'pagination pagination-sm float-right mb-0 mt-3 mr-4'" :page-class="'page-item'"
          :prev-class="'page-item prev'" :next-class="'page-item next'" :page-link-class="'page-link'"
          :prev-link-class="'page-link'" :next-link-class="'page-link'"></paginate>
      </div>
    </div>
  </div>
</template>

<script>
  import helpers from "@/helpers.js";
  import CommentRow from "./comment_row";
  import VueSkeletonLoader from 'skeleton-loader-vue';
  export default {
    components: {
      CommentRow,VueSkeletonLoader,
    },

    data: function () {
      return {
        page: 0,
        fullPage: "",
        isLoader: true,
      };
    },

    computed: {
      comments: function () {
        return this.$store.getters["comments/comments"];
      },
      totalPages: function () {
        return this.$store.getters["comments/totalPages"];
      },
    },

    created: function () {
      this.page = helpers.getPageQuery();
    },

    watch: {
      page: function (val) {
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.isLoader =true;
        this.$store.dispatch("comments/getAllComments", val);
        setTimeout(() => {
          // loader.hide();
          this.isLoader = false;
        }, 200);
      },
    },

    methods: {
      setPage(page) {
        this.page = page;
        this.$router.push("comments?page=" + page);
      },
    },
  };
</script>
<style scoped>
  .custom {
    position: absolute;
    z-index: 999;
    top: 246px;
    left: 40%;
    opacity: 0.5;
  }
</style>